// Single source of truth for the labels and severities of signup status
// codes returned by the backend in `signup_status`. Used by:
//   - CreationReportDialog (per-row chip in const-batch report)
//   - SignupResultSnackbar (toast after a single admin signup)
// Status codes are produced by `UserToLessonService.classify_signup_result`
// in backend/api/services/user_to_lesson.py.
export const SIGNUP_STATUS_LABELS = {
  signed_with_pass: { label: "Z karnetu", color: "success" },
  signed_pass_exhausted: {
    label: "Z karnetu — ostatnie wejście",
    color: "warning",
  },
  signed_no_pass_unpaid: { label: "Bez karnetu — DŁUG", color: "error" },
  signed_on_site_unpaid: { label: "Płatne na miejscu", color: "default" },
  signed_split_pending: {
    label: "Płatność podzielona — oczekująca",
    color: "info",
  },
  signed_online_pending: {
    label: "Płatność online — oczekująca",
    color: "info",
  },
  signed_free: { label: "Darmowe", color: "success" },
  skipped_payment_required: {
    label: "Pominięto — wymagana płatność online",
    color: "info",
  },
  waitlisted: { label: "Lista oczekujących", color: "default" },
  failed: { label: "Błąd", color: "error" },
  already_enrolled: { label: "Już zapisany", color: "default" },
  manually_paid: { label: "Oznaczone jako opłacone", color: "success" },
  removed: { label: "Wypisano z zajęć", color: "default" },
};

// Statuses that admin must acknowledge — auto-dismiss disabled for these.
export const ATTENTION_STATUSES = new Set([
  "signed_pass_exhausted",
  "signed_no_pass_unpaid",
  "failed",
]);

// Map MUI Chip color → MUI Alert severity. Alerts only support
// "success"|"info"|"warning"|"error"; "default" falls back to "info".
const CHIP_COLOR_TO_SEVERITY = {
  success: "success",
  warning: "warning",
  error: "error",
  info: "info",
  default: "info",
};

export const severityForStatus = (status) => {
  const meta = SIGNUP_STATUS_LABELS[status];
  return CHIP_COLOR_TO_SEVERITY[meta?.color] || "info";
};
